import http from './http';

const pageStatusService = {
  async getPageStatus(student_id: any) {
    const res = await http.get(`api/page-status/student/${student_id}`);
    return res;
  },

  async getPageStatusByPageName(student_id: any, page_name: any): Promise<any> {
    const res = await http.get(`api/page-status/student/${student_id}/page/${page_name}`);
    return res;
  }
};

export default pageStatusService;